import { TypeTextObj } from './elementType';
export const ANSWER_NONE = 'NONE';
export const WORD_COUNT_HINT = 'WORD_COUNT_HINT';
export const LETTER_COUNT_HINT = 'LETTER_COUNT_HINT';
export const answerShowTypeList: TypeTextObj[] = [
  {
    type: ANSWER_NONE,
    text: '不提示',
  },
  {
    type: WORD_COUNT_HINT,
    text: '提示单词数',
  },
  {
    type: LETTER_COUNT_HINT,
    text: '提示字母数',
  },
];
export const answerShowTypeMap = {
  NONE: '不提示',
  WORD_COUNT_HINT: '提示单词数',
  LETTER_COUNT_HINT: '提示字母数',
};
